import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { useImagePreviewHandlers, useImagePreviewState } from "../../image-preview-context";
import { Tool } from "./tool";
import { ToolboxToolProps } from "./toolbox.types";
import { Group } from "../../../group";
import { Kbd } from "@mantine/core";

/**
 * Previous tool for the ImagePreview toolbox. Switches to the previous image in the gallery.
 */
export const Previous = (props: ToolboxToolProps) => {
    const handlers = useImagePreviewHandlers();
    const { images } = useImagePreviewState();
    if (images.length <= 1) return null;
    return (
        <Tool
            icon={faChevronLeft}
            label={
                <Group>
                    Previous <Kbd>←</Kbd>
                </Group>
            }
            onClick={handlers.previous}
            {...props}
        />
    );
};
